import '@babel/polyfill'
import firebase from 'firebase/app'
import 'firebase/auth'
import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import './plugins/vuetify'
import App from './App.vue'

Vue.config.productionTip = false
Vue.use(Vuetify)

firebase.initializeApp({
  apiKey: "AIzaSyAQ6Lx9iiurwrSZ0xLHevVFzGQoHYo5GBo",
  authDomain: "who-is-on-support.firebaseapp.com",
  databaseURL: "https://who-is-on-support.firebaseio.com",
  projectId: "who-is-on-support"
});

new Vue({
  vuetify: new Vuetify(),
  render: h => h(App)
}).$mount('#app')
